import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { RootState } from 'app/app.module';
import {ACTIVE_ACCOUNT_PARAM, PX_LOGIN_PARAM, LocalStorageService} from 'app/local-storage.service';
import { userDataSelector } from 'app/state/app/app.selectors';
import { UserService } from '../user/user.service';
import {rotateChevron} from "../../app.animations";
import {BehaviorSubject, Subscription} from "rxjs";
import {DispatcherLocationToggleService} from "../../dispatcherLocationToggle.service";
import {environment} from "../../../environments/environment";

@Component({
	selector: 'header-bar',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	animations: [rotateChevron]
})

export class HeaderComponent implements OnInit, OnDestroy {

	public userName: string;

	public text: string;

	public companyName: string;

	public headerItems;

	public expanded = false;

	public account = '';

	public showDLComponent$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

	public showLocationFilter$ = new BehaviorSubject(false);

	public isPxLogin;

	canViewELDxLinks = false;
	dispatcherLocationSubscription: Subscription;
	locationSubscription: Subscription;

	constructor(
		public router: Router,
		public users: UserService,
		public dispatcherLocationToggleService: DispatcherLocationToggleService,
		private activatedRoute: ActivatedRoute,
		private store: Store<RootState>,
		private localStorageService: LocalStorageService,
		private cdr: ChangeDetectorRef
	) {
		this.account = this.localStorageService.get(ACTIVE_ACCOUNT_PARAM);
		//bug when first load, localstorage is null
		this.localStorageService.sideNavSetBehaviorSubject.subscribe((val) => {
			if (val) {
				this.isPxLogin = this.localStorageService.get(PX_LOGIN_PARAM);
			}
		})

	}

	ngOnDestroy(){
		this.dispatcherLocationSubscription.unsubscribe();
		this.locationSubscription.unsubscribe();

	}

	ngOnInit() {
		this.headerItems = [
			{
				label: 'Logout',
				routerLink: 'logout'
			}
		];
		this.store.select(userDataSelector).subscribe((user) => {
			if(user.userEmail) {
				this.canViewELDxLinks = environment.canViewELDxNewLinks.includes(user?.userEmail);
			}
			this.userName = user.displayName;
			this.companyName = user.companyName;
			this.cdr.detectChanges();
		});
		this.dispatcherLocationSubscription = this.dispatcherLocationToggleService.getToggleStatus().subscribe(showHide => {
			this.showDLComponent$.next(showHide);
		});
		this.locationSubscription = this.dispatcherLocationToggleService.getLocationFilterStatus().subscribe(showHide => {
			this.showLocationFilter$.next(showHide);
		});
	}

	goToRoute(routeAsString) {
		this.router.navigate(['/' + routeAsString]);
	}
}
